(($, Drupal) => {
  "use strict";

  const imaginatorSlickSlider = (context) => {
    const $sliderFor = $(".slider-for", context).not('.slick-initialized');
    const $sliderNav = $(".slider-nav", context).not('.slick-initialized');

    // Initialize main slider if it exists
    if ($sliderFor.length) {
      $sliderFor.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        accessibility: false,
      });

      // Add download button functionality to the main slider
      $sliderFor.on('click', '.imaginator-image-download', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // Get associated image data
        const $image = $(this).closest('.imaginator-image').find('img');
        const imageUrl = $image.attr('src');
        const altText = $image.attr('alt') || 'downloaded-image';

        // Extract file extension
        const extension = imageUrl.split('.').pop().split(/[?#]/)[0];
        const filename = `${altText.replace(/[^a-z0-9]/gi, '_')}.${extension}`;

        // Create temporary download link
        const $anchor = $('<a>', {
          href: imageUrl,
          download: filename
        }).hide().appendTo('body');

        $anchor[0].click();
        $anchor.remove();
      });

      $('.imaginator-images .slider-for').once('simple-lightbox').each(function () {
        // Initialize lightbox on all the anchor tags
        const lightbox = new SimpleLightbox('.imaginator-images .slider-for .imaginator-image-expand a', {
          widthRatio: 0.95,
          heightRatio: 0.95,
          scaleImageToRatio: true,
        });

        // Prevent default link navigation for anchors
        $(this).on('click', '.imaginator-image-expand a', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        });

        // Open lightbox by simulating a click on the anchor inside the clicked expand button
        $(this).on('click', '.imaginator-image-expand', function(e) {
          e.preventDefault();

          // Find the anchor inside the expand button
          const $anchor = $(this).find('a');
          if ($anchor.length) {
            $anchor[0].click(); // triggers Simple Lightbox on this image
          }
        });
      });
    }

    // Initialize navigation slider if it exists
    if ($sliderNav.length) {
      $sliderNav.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: $sliderFor,
        dots: false,
        centerMode: false,
        focusOnSelect: false,
      });

      // Syncs the navigation slider (`slider-nav`) with the main slider (`slider-for`):
      // - Adds a click event to navigation slides.
      // - When a slide in the navigation is clicked, the main slider jumps to the corresponding slide.
      $sliderNav.find(".slick-slide").on("click", function () {
        const index = $(this).data("slickIndex");
        $sliderFor.slick("slickGoTo", index);
      });

      // Automatically navigate to the pre-selected slide in the main slider:
      // - Checks if there is a `.selected` slide in the navigation.
      // - If a selected slide exists, the main slider is updated to display it.
      const $selectedImage = $sliderNav.find(".slick-slide.selected");
      if ($selectedImage.length) {
        const selectedIndex = $selectedImage.data("slickIndex");
        $sliderFor.slick("slickGoTo", selectedIndex);
      }
    }

    // One lightbox instance per student card, scoped to that card's links only.
    $('.olex-reader-images', context).once('olex-reader-lightbox').each(function () {
      new SimpleLightbox(this.querySelectorAll('a'), {
        widthRatio: 0.95,
        heightRatio: 0.95,
        scaleImageToRatio: true,
        disableScroll: false,
      });
    });
  };

  // Implements the `imaginatorSlickSlider` behavior to initialize Slick sliders
  // and SimpleLightbox for image galleries within the context of Drupal.
  Drupal.behaviors.imaginatorSlickSlider = {
    attach: function (context, settings) {
      imaginatorSlickSlider(context);
    },
  };
})(jQuery, Drupal);
